import { render, staticRenderFns } from "./ProductModifyMakeListTable.vue?vue&type=template&id=353d4c5e&scoped=true&"
import script from "./ProductModifyMakeListTable.vue?vue&type=script&lang=js&"
export * from "./ProductModifyMakeListTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductModifyMakeListTable.vue?vue&type=style&index=0&id=353d4c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353d4c5e",
  null
  
)

export default component.exports